// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__OVVBq","col":"styles_col__2PJel","fulfillmentStatus":"styles_fulfillmentStatus__fWYiO","emailCol":"styles_emailCol__2_RPe"};